module.exports = __webpack_public_path__ + "static/brownbearsuitcase-0162b908431ab5df768c6eaf316a2c98.jpeg";